(ns aws.cognito.errors
  (:require [goog.object :as gobj]))

(defn- code [error]
  (gobj/get error "code"))

(defn- error-code? [type error]
  (= (code error) type))

(def invalid-parameter-exception?
  (partial error-code? "InvalidParameterException"))

(def user-not-confirmed-exception?
  (partial error-code? "UserNotConfirmedException"))

(def not-authorized-exception?
  (partial error-code? "NotAuthorizedException"))
